const number = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatUsd = (value) => `US$ ${number.format(value || 0)}`;
export const formatBob = (value) => `Bs. ${number.format(value || 0)}`;

export function formatCurrency(value, settings) {
  const amount = Number(value || 0);
  const rate = Number(settings?.usd_to_bob || 6.96);
  const mode = settings?.display_mode || "USD";
  if (mode === "BOB") return formatBob(amount * rate);
  if (mode === "BOTH") return `${formatUsd(amount)} · ${formatBob(amount * rate)}`;
  return formatUsd(amount);
}

